import {
  defineStyle,
  defineStyleConfig,
  SystemStyleObject,
} from '@chakra-ui/react';

const baseBadgeVariant: SystemStyleObject = {
  fontWeight: 'medium',
  textTransform: 'none',
  lineHeight: 'short',
  py: 2,
  px: 3,
  borderRadius: '100px',
  userSelect: 'none',
};

const yPrimary: SystemStyleObject = defineStyle({
  ...baseBadgeVariant,
  bg: 'yPrimary.100',
  color: 'yPrimary.700',
});

const yYellow: SystemStyleObject = defineStyle({
  ...baseBadgeVariant,
  bg: 'yYellow.100',
  color: 'yYellow.700',
});

const yGreen: SystemStyleObject = defineStyle({
  ...baseBadgeVariant,
  bg: 'yGreen.100',
  color: 'yGreen.700',
});

const ySecondary: SystemStyleObject = defineStyle({
  ...baseBadgeVariant,
  bg: 'ySecondary.100',
  color: 'ySecondary.700',
});

const yGray: SystemStyleObject = defineStyle({
  ...baseBadgeVariant,
  bg: 'yGray.100',
  color: 'yGray.700',
});

const loading: SystemStyleObject = defineStyle({
  ...baseBadgeVariant,
  bg: 'yGray.50',
  color: 'transparent',
  pointerEvents: 'none',
});

const yRed: SystemStyleObject = defineStyle({
  ...baseBadgeVariant,
  bg: 'yRed.100',
  color: 'yRed.700',
});

const yOrange: SystemStyleObject = defineStyle({
  ...baseBadgeVariant,
  bg: 'yOrange.100',
  color: 'yOrange.700',
});

export enum BadgeThemeKeys {
  YOOGA_GRAY = 'yooga-gray',
  YOOGA_PRIMARY = 'yooga-primary',
  YOOGA_SECONDARY = 'yooga-secondary',
  YOOGA_GREEN = 'yooga-green',
  YOOGA_RED = 'yooga-red',
  YOOGA_YELLOW = 'yooga-yellow',
  YOOGA_ORANGE = 'yooga-orange',
  LOADING = 'loading',
}

const badgeVariants: Record<BadgeThemeKeys, SystemStyleObject> = {
  [BadgeThemeKeys.YOOGA_PRIMARY]: yPrimary,
  [BadgeThemeKeys.YOOGA_SECONDARY]: ySecondary,
  [BadgeThemeKeys.YOOGA_RED]: yRed,
  [BadgeThemeKeys.YOOGA_YELLOW]: yYellow,
  [BadgeThemeKeys.YOOGA_GREEN]: yGreen,
  [BadgeThemeKeys.YOOGA_ORANGE]: yOrange,
  [BadgeThemeKeys.YOOGA_GRAY]: yGray,
  [BadgeThemeKeys.LOADING]: loading,
};

export const badgeTheme = defineStyleConfig({
  variants: badgeVariants,
});
